module.exports = __webpack_public_path__ + "static/media/tceq.fc692136.jpg";